import React, { useState, useEffect } from 'react'

const API = '/cms/api/contracts'

export default function PartnerContractPage() {
  const [tab, setTab] = useState('apply')
  const [contracts, setContracts] = useState([])
  const [loading, setLoading] = useState(false)
  const [applying, setApplying] = useState(false)
  const [error, setError] = useState('')
  const [msg, setMsg] = useState('')
  const [detail, setDetail] = useState(null)         // 详情弹窗

  const getInstitutionId = () => {
    try {
      const user = JSON.parse(localStorage.getItem('cms_user') || '{}')
      return user.institutionId || ''
    } catch (e) { return '' }
  }

  const getUserRole = () => {
    try {
      const user = JSON.parse(localStorage.getItem('cms_user') || '{}')
      return user.role || ''
    } catch (e) { return '' }
  }

  const [form, setForm] = useState({
    company_name: '',
    credit_code: '',
    legal_person: '',
    contact_name: '',
    contact_phone: '',
    contact_email: '',
    apply_type: 'workshop_enroll_v1',  // 合作类型
    remarks: ''
  })

  const instId = getInstitutionId()

  const loadContracts = async () => {
    if (!instId) return
    setLoading(true)
    try {
      const r = await fetch(`${API}/my/${instId}?type=partner_apply`)
      const d = await r.json()
      if (d.success) setContracts(d.data)
    } catch (e) { setError('加载失败') }
    setLoading(false)
  }

  useEffect(() => { if (tab === 'my') loadContracts() }, [tab])

  // 提交申请
  const handleSubmit = async () => {
    if (!form.company_name) return setError('请填写机构/公司名称')
    if (!form.contact_name) return setError('请填写联系人')
    if (!form.contact_phone) return setError('请填写联系电话')
    setError('')
    setMsg('')
    setApplying(true)
    try {
      const r = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          type: 'partner_apply',
          institution_id: instId,
          plan_type: form.apply_type   // 合作类型存到plan_type字段
        })
      })
      const d = await r.json()
      if (d.success) {
        setMsg(`提交成功！合同编号：${d.data.contract_no}，请等待总部审核。`)
        setForm({ company_name: '', credit_code: '', legal_person: '', contact_name: '', contact_phone: '', contact_email: '', apply_type: 'workshop_enroll_v1', remarks: '' })
      } else {
        setError(d.error || '提交失败')
      }
    } catch (e) { setError('网络错误') }
    setApplying(false)
  }

  // 查看详情
  const handleViewDetail = async (id) => {
    try {
      const r = await fetch(`${API}/${id}`)
      const d = await r.json()
      if (d.success) setDetail(d.data)
      else setError(d.error || '加载失败')
    } catch (e) { setError('网络错误') }
  }

  // 签署
  const handleSign = async (id) => {
    if (!confirm('确认签署此合同？')) return
    try {
      // v3 (2026-09-01 接管): 签署改走专用 /sign 端点（PUT /:id 现需管理员权限）
      const r = await fetch(`${API}/${id}/sign`, { method: 'POST' })
      const d = await r.json()
      if (d.success) { loadContracts(); setMsg('签署成功！'); setDetail(null) }
      else setError(d.error || '签署失败')
    } catch (e) { setError('网络错误') }
  }

  // 上传扫描件
  const handleUpload = async (id, role) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.pdf,.jpg,.jpeg,.png,.gif'
    input.onchange = async (e) => {
      const file = e.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      try {
        const r = await fetch(`${API}/${id}/upload?role=${role}`, { method: 'POST', body: formData })
        const d = await r.json()
        if (d.success) {
          setMsg('上传成功！')
          handleViewDetail(id)  // 刷新详情
        } else setError(d.error || '上传失败')
      } catch (e) { setError('网络错误') }
    }
    input.click()
  }

  const getStatusText = (status) => {
    const map = { pending: '⏳ 待审核', approved: '✅ 已通过', signed: '📝 已签署', rejected: '❌ 已拒绝', expired: '🕐 已过期' }
    return map[status] || status
  }

  const getStatusColor = (status) => {
    const map = { pending: '#faad14', approved: '#52c41a', signed: '#1890ff', rejected: '#f5222d' }
    return map[status] || '#999'
  }

  const APPLY_TYPES = {
    workshop_enroll_v1: '企业大脑装机陪跑服务协议',
    level4_private_v1: '企业大脑服务层·私有部署年度服务合同',
    skill_license_v1: 'SKILL定制成果授权使用协议',
    sidonghui_v1: '企业大脑服务层·服务商孵化与席位协议',
    saas_upgrade: 'SaaS软件升级',
    course_cooperation: '课程合作（七彩故事工坊等）',
    regional_agent: '区域代理',
    other: '其他合作'
  }

  const tabStyle = (t) => ({
    padding: '8px 20px',
    cursor: 'pointer',
    borderBottom: tab === t ? '2px solid #1890ff' : '2px solid transparent',
    color: tab === t ? '#1890ff' : '#666',
    fontWeight: tab === t ? 600 : 400,
    fontSize: 14
  })

  const cell = { padding: '8px 10px', borderBottom: '1px solid #eee', fontSize: 13 }
  const headerCell = { ...cell, fontWeight: 600, background: '#fafafa', color: '#333' }

  // 详情弹窗

  // 2026-09-17 企业大脑合同模板在线预览(客户可见全文;接口 GET /templates/:id 公开)
  const [tpl, setTpl] = useState(null)

  const openTpl = async (id) => {
    try {
      const r = await fetch(`${API}/templates/${id}`)
      const d = await r.json()
      if (d.success) setTpl({ ...d.data, text: String(d.data.text || '').replace(/\{\{(.+?)\}\}/g, '＿＿＿＿') })
      else alert(d.error || '模板加载失败')
    } catch (e) { alert('网络错误') }
  }


  // 2026-09-17 详情弹窗:按申请单数据预填合同正文(POST /render;缺失变量填 ＿＿＿_;失败退回通用模板)
  const openMyTpl = async (id, d) => {
    try {
      const r = await fetch(`${API}/templates/${id}`)
      const t = await r.json()
      if (!t.success) { alert(t.error || '模板加载失败'); return }
      const derived = {
        '甲方名称': d.company_name || '＿＿＿＿',
        '统一社会信用代码': d.credit_code || '＿＿＿＿',
        '联系人': d.contact_name || '＿＿＿＿',
        '联系电话': d.contact_phone || '＿＿＿＿',
        '联系邮箱': d.contact_email || '＿＿＿＿',
      }
      const variables = {}
      ;(t.data.variables || []).forEach(v => { variables[v.name] = derived[v.name] || '＿＿＿＿' })
      const r2 = await fetch(`${API}/templates/${id}/render`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variables })
      })
      const r2j = await r2.json()
      if (r2j.success && r2j.data && r2j.data.content) {
        setTpl({ ...t.data, prefilled: true, text: String(r2j.data.content).replace(/\{\{(.+?)\}\}/g, '＿＿＿＿') })
      } else {
        setTpl({ ...t.data, text: String(t.data.text || '').replace(/\{\{(.+?)\}\}/g, '＿＿＿＿') })
      }
    } catch (e) { alert('网络错误') }
  }

  const TplText = ({ text }) => {
    if (!text) return null
    return (
      <div style={{ fontSize: 13, lineHeight: 1.8, whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
        {String(text).split('\n').map((ln, i) => {
          const h = ln.match(/^#{1,4}\s+(.*)$/)
          if (h) return <div key={i} style={{ fontWeight: 700, margin: '10px 0 4px' }}>{h[1]}</div>
          const parts = ln.split(/\*\*(.+?)\*\*/g)
          return <div key={i}>{parts.map((p, j) => (j % 2 === 1 ? <strong key={j}>{p}</strong> : p))}</div>
        })}
      </div>
    )
  }

  const TemplateModal = () => {
    if (!tpl) return null
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setTpl(null)}>
        <div style={{ background: '#fff', borderRadius: 8, width: 760, maxHeight: '85vh', overflow: 'auto', padding: 28 }} onClick={e => e.stopPropagation()}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={{ margin: 0, fontSize: 17 }}>📄 {tpl.title}</h3>
            <span onClick={() => setTpl(null)} style={{ cursor: 'pointer', color: '#999', fontSize: 20, lineHeight: 1 }}>✕</span>
          </div>
          <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 6, padding: '8px 12px', fontSize: 12, color: '#d46b08', marginBottom: 14 }}>
            {tpl.prefilled ? '以下为按贵司申请信息预填的合同正文；＿＿＿＿ 处待双方确认填写，最终以双方确认并盖章的正式合同为准。' : '以下为合同模板全文；金额、日期等条款以双方确认并盖章的正式合同为准。'}
          </div>
          <TplText text={tpl.text} />
        </div>
      </div>
    )
  }

  const DetailModal = () => {
    if (!detail) return null
    const d = detail
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.45)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }} onClick={() => setDetail(null)}>
        <div style={{
          background: '#fff', borderRadius: 8, width: 680, maxHeight: '85vh',
          overflow: 'auto', padding: 28
        }} onClick={e => e.stopPropagation()}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <h3 style={{ margin: 0, fontSize: 18 }}>📄 {d.contract_no}</h3>
            <span style={{ color: getStatusColor(d.status), fontWeight: 600, fontSize: 14 }}>
              {getStatusText(d.status)}
            </span>
          </div>

          {/* 基本信息 */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, fontSize: 13, marginBottom: 16 }}>
            <div><strong style={{ color: '#666' }}>合作类型：</strong>{APPLY_TYPES[d.plan_type] || d.plan_type || '-'}</div>
            <div><strong style={{ color: '#666' }}>公司名称：</strong>{d.company_name || '-'}</div>
            <div><strong style={{ color: '#666' }}>信用代码：</strong>{d.credit_code || '-'}</div>
            <div><strong style={{ color: '#666' }}>法定代表人：</strong>{d.legal_person || '-'}</div>
            <div><strong style={{ color: '#666' }}>联系人：</strong>{d.contact_name || '-'}</div>
            <div><strong style={{ color: '#666' }}>联系电话：</strong>{d.contact_phone || '-'}</div>
            <div><strong style={{ color: '#666' }}>联系邮箱：</strong>{d.contact_email || '-'}</div>
            <div><strong style={{ color: '#666' }}>创建时间：</strong>{d.created_at || '-'}</div>
          </div>

          {d.remarks && (
            <div style={{ background: '#f5f5f5', borderRadius: 6, padding: 12, fontSize: 13, marginBottom: 16 }}>
              <strong style={{ color: '#666' }}>备注：</strong>{d.remarks}
            </div>
          )}

          {d.reject_reason && (
            <div style={{ background: '#fff2f0', borderRadius: 6, padding: 12, fontSize: 13, marginBottom: 16 }}>
              <strong style={{ color: '#f5222d' }}>拒绝原因：</strong>{d.reject_reason}
            </div>
          )}

          {['workshop_enroll_v1','level4_private_v1','skill_license_v1','sidonghui_v1'].includes(d.plan_type) && (
            <div style={{ marginBottom: 16 }}>
              <button onClick={() => openMyTpl(d.plan_type, d)} style={{ padding: '8px 18px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>📄 查看合同正文（按申请信息预填）</button>
              <span style={{ fontSize: 12, color: '#999', marginLeft: 10 }}>签署以双方确认盖章版为准</span>
            </div>
          )}
          {/* 合同文件区域 */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>📎 合同文件</div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {/* 机构扫描件 */}
              <div style={{
                border: '1px solid #d9d9d9', borderRadius: 6, padding: 12, flex: 1, minWidth: 200
              }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>机构已盖章扫描件</div>
                {d.file_org ? (
                  <div>
                    <a href={d.file_org} target="_blank" rel="noreferrer" style={{ color: '#1890ff', fontSize: 13 }}>👁 查看文件</a>
                  </div>
                ) : (
                  <span style={{ color: '#999', fontSize: 12 }}>暂未上传</span>
                )}
                {d.status === 'approved' && (
                  <button onClick={() => handleUpload(d.id, 'org')} style={{
                    marginTop: 6, background: '#1890ff', color: '#fff', border: 'none',
                    borderRadius: 3, padding: '4px 10px', fontSize: 12, cursor: 'pointer'
                  }}>📤 上传盖章扫描件</button>
                )}
              </div>
              {/* 总部盖章版 */}
              <div style={{
                border: '1px solid #d9d9d9', borderRadius: 6, padding: 12, flex: 1, minWidth: 200
              }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>总部已盖章版</div>
                {d.file_hq ? (
                  <a href={d.file_hq} target="_blank" rel="noreferrer" style={{ color: '#1890ff', fontSize: 13 }}>👁 查看文件</a>
                ) : (
                  <span style={{ color: '#999', fontSize: 12 }}>暂未上传</span>
                )}
              </div>
            </div>
          </div>

          {/* 操作按钮 */}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            {d.status === 'approved' && (
              <button onClick={() => handleSign(d.id)} style={{
                background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4,
                padding: '8px 20px', cursor: 'pointer', fontSize: 13, fontWeight: 600
              }}>✍️ 签署合同</button>
            )}
            <button onClick={() => setDetail(null)} style={{
              background: '#f5f5f5', color: '#666', border: '1px solid #d9d9d9',
              borderRadius: 4, padding: '8px 20px', cursor: 'pointer', fontSize: 13
            }}>关闭</button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ padding: 24, maxWidth: 960, margin: '0 auto' }}>
      <h2 style={{ margin: '0 0 20px 0', fontSize: 20 }}>📄 合同与合作</h2>
      <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid #e8e8e8', marginBottom: 20 }}>
        <div style={tabStyle('apply')} onClick={() => setTab('apply')}>🤝 申请合作</div>
        <div style={tabStyle('my')} onClick={() => { setTab('my'); loadContracts() }}>📋 我的合同</div>
      </div>

      {error && <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', color: '#f5222d', padding: '10px 16px', borderRadius: 4, marginBottom: 16 }}>{error}</div>}
      {msg && <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', color: '#52c41a', padding: '10px 16px', borderRadius: 4, marginBottom: 16 }}>{msg}</div>}

      {tab === 'apply' ? (
        <div>
          {/* === 合同模板预览 === */}
          <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: '8px', padding: '16px 20px', marginBottom: '20px' }}>
            <div style={{ fontSize: '15px', fontWeight: 600, color: '#d46b08', marginBottom: '10px' }}>📄 标准合同模板（点击预览/下载）</div>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>以下为总部标准合作合同，申请前请先了解条款内容：</div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {[
                { name: '七彩故事工坊合作协议', file: 'boxiaotu_story_cooperation.html' },
                { name: 'SaaS升级服务协议', file: 'boxiaotu_saas_upgrade.html' },
                { name: '区域代理协议', file: 'boxiaotu_regional_agent.html' },
                { name: '总部推广员合作协议', file: 'boxiaotu_promoter.html' }
              ].map(t => (
                <a key={t.file} href={'https://api.boxiaotu.cn/storage/contracts/' + t.file} target="_blank" rel="noopener noreferrer"
                  style={{ background: '#fff', border: '1px solid #d9d9d9', borderRadius: '6px', padding: '10px 14px', textDecoration: 'none', color: '#333', fontSize: '13px', flex: '1', minWidth: '160px' }}>
                  📋 {t.name} <span style={{ color: '#1890ff' }}>→ 查看</span>
                </a>
              ))}
            </div>
          </div>

          {/* === 企业大脑合同模板(在线预览全文) === */}
          <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: '8px', padding: '16px 20px', marginBottom: '20px' }}>
            <div style={{ fontSize: '15px', fontWeight: 600, color: '#d46b08', marginBottom: '10px' }}>📄 企业大脑合同模板（点击在线查看全文）</div>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>实战营 / 私有部署 / SKILL授权 / 服务商孵化 —— 申请前请先阅读对应条款</div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {[
                { id: 'workshop_enroll_v1', name: '企业大脑实战营服务协议' },
                { id: 'level4_private_v1', name: '私有部署年度服务合同' },
                { id: 'skill_license_v1', name: 'SKILL 定制成果授权协议' },
                { id: 'sidonghui_v1', name: '服务商孵化与席位协议' }
              ].map(t => (
                <div key={t.id} onClick={() => openTpl(t.id)}
                  style={{ background: '#fff', border: '1px solid #d9d9d9', borderRadius: '6px', padding: '10px 14px', color: '#333', fontSize: '13px', flex: '1', minWidth: '160px', cursor: 'pointer' }}>
                  📄 {t.name} <span style={{ color: '#1890ff' }}>→ 在线预览</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>选择合作类型并填写信息，提交后等待总部审核。</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>合作类型 *</label>
              <select value={form.apply_type} onChange={e => setForm({...form, apply_type: e.target.value})} style={inputStyle}>
                {Object.entries(APPLY_TYPES).map(([k, v]) => (
                  <option key={k} value={k}>{v}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>机构/公司名称 *</label>
              <input value={form.company_name} onChange={e => setForm({...form, company_name: e.target.value})} style={inputStyle} placeholder="请填写机构全称" />
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>统一社会信用代码</label>
              <input value={form.credit_code} onChange={e => setForm({...form, credit_code: e.target.value})} style={inputStyle} placeholder="如：91440101XXXXXX" />
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>法定代表人</label>
              <input value={form.legal_person} onChange={e => setForm({...form, legal_person: e.target.value})} style={inputStyle} placeholder="法人姓名" />
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>联系人 *</label>
              <input value={form.contact_name} onChange={e => setForm({...form, contact_name: e.target.value})} style={inputStyle} placeholder="姓名" />
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>联系电话 *</label>
              <input value={form.contact_phone} onChange={e => setForm({...form, contact_phone: e.target.value})} style={inputStyle} placeholder="手机号" />
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#666' }}>联系邮箱</label>
              <input value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} style={inputStyle} placeholder="邮箱地址" />
            </div>
          </div>
          <div style={{ marginTop: 12 }}>
            <label style={{ fontSize: 12, color: '#666' }}>备注信息</label>
            <textarea value={form.remarks} onChange={e => setForm({...form, remarks: e.target.value})} rows={3} style={{ ...inputStyle, width: '100%', resize: 'vertical' }} placeholder="其他需要说明的内容" />
          </div>
          <button onClick={handleSubmit} disabled={applying} style={{
            marginTop: 16, padding: '10px 32px', background: '#1890ff', color: '#fff',
            border: 'none', borderRadius: 4, fontSize: 15, cursor: 'pointer', opacity: applying ? 0.6 : 1
          }}>
            {applying ? '提交中...' : '提交合作申请'}
          </button>
        </div>
      ) : (
        <div>
          {loading ? <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>加载中...</div> : (
            contracts.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>📄</div>
                <p>暂无合同记录</p>
                <p style={{ fontSize: 12 }}>提交合作申请后，合同将在这里显示</p>
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>{['合同编号', '合作类型', '状态', '创建时间', '操作'].map(h => <th key={h} style={headerCell}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {contracts.map(c => (
                    <tr key={c.id}>
                      <td style={cell}>{c.contract_no}</td>
                      <td style={cell}>{APPLY_TYPES[c.plan_type] || c.plan_type || '合作申请'}</td>
                      <td style={cell}><span style={{ color: getStatusColor(c.status), fontWeight: 600 }}>{getStatusText(c.status)}</span></td>
                      <td style={cell}>{c.created_at}</td>
                      <td style={cell}>
                        <button onClick={() => handleViewDetail(c.id)} style={{
                          background: '#1890ff', color: '#fff', border: 'none',
                          borderRadius: 3, padding: '4px 10px', cursor: 'pointer', fontSize: 12, marginRight: 4
                        }}>👁 详情</button>
                        {c.status === 'approved' && (
                          <button onClick={() => handleSign(c.id)} style={{
                            background: '#52c41a', color: '#fff', border: 'none',
                            borderRadius: 3, padding: '4px 10px', cursor: 'pointer', fontSize: 12
                          }}>✍️ 签署</button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          )}
        </div>
      )}

      <DetailModal />
      <TemplateModal />
    </div>
  )
}

const inputStyle = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid #d9d9d9',
  borderRadius: 4,
  fontSize: 13,
  outline: 'none',
  boxSizing: 'border-box'
}
